var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "start"
  }, [_c('send-sample-dialog', {
    attrs: {
      "samples": _vm.EXAMPLES
    }
  }), _c('start-header', {
    attrs: {
      "media": {
        id: '692658bb-99df-4546-abed-5deee95277e3',
        alt: 'Invitations',
        video: true
      },
      "bg": {
        src: 'https://cdn.ellacard.com/media/79a3cfe8-f198-4fc9-b619-36bb35384f66/lg.mp4',
        color: '#EF9C7E'
      },
      "to": {
        name: 'catalog-category',
        params: {
          category: 'invitations'
        },
        hash: '#search'
      }
    },
    on: {
      "click-laptop": function ($event) {
        _vm.global.lastSelectedType = 'INVITATION';
      }
    },
    scopedSlots: _vm._u([{
      key: "h1",
      fn: function () {
        return [_vm._v("Invitations from Ellacard")];
      },
      proxy: true
    }, {
      key: "h2",
      fn: function () {
        return [_vm._v("The best way to create and send beautiful custom invitations and collect RSVPs.")];
      },
      proxy: true
    }])
  }), _c('start-layer', {
    attrs: {
      "clip-waves-class": "light-gradient",
      "offset": .75
    }
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-category',
        params: {
          category: 'invitations'
        },
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'INVITATION';
      }
    }
  }, [_vm._v("Start an invitation "), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "pink",
      "to": {
        hash: '#demo-first-birthday'
      }
    }
  }, [_vm._v("Try demo…")])], 1), _c('div', {
    staticClass: "grid-alternate"
  }, [_c('web-media', {
    staticClass: "hover-pop rounded-xl white",
    attrs: {
      "aspect-ratio": "4 / 3",
      "id": "3cedcd52-e788-442c-9ba7-bd207dca0ce0",
      "alt": "Ellacard invitation customization examples",
      "is-video": ""
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _vm._v(" Customize everything")], 1), _c('div', [_vm._v(" Use our design tools to add your own pages with your own flare, complete with confetti, music, and backgrounds. ")])]), _c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "1"
    }
  }, [_c('div', {
    staticClass: "absolute rounded rn2 overflow-auto",
    staticStyle: {
      "width": "85%",
      "top": "0",
      "left": "0",
      "max-height": "100%"
    }
  }, [_c('web-media', {
    staticClass: "white",
    attrs: {
      "aspect-ratio": "902 / 1282",
      "id": "ef377a9f-b5cc-4736-9cf2-ee5c9055cd36",
      "alt": "Example guest list"
    }
  })], 1), _c('web-media', {
    staticClass: "absolute rounded r5 white",
    staticStyle: {
      "width": "50%",
      "top": "15%",
      "right": "0"
    },
    attrs: {
      "aspect-ratio": "444 / 640",
      "id": "733f122c-01fb-47a1-ad70-a0447f941acd",
      "alt": "Example RSVP form"
    }
  })], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendarQuestion)
    }
  }), _vm._v(" Collect RSVPs")], 1), _c('div', [_vm._v(" Ask whatever questions you want with your own custom RSVP form. Set permissions for who can respond. We'll keep track of all the responses. ")])]), _c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "4 / 3"
    }
  }, [_c('div', {
    staticClass: "absolute rounded grey lighten-5 d-flex flex-column rn5",
    staticStyle: {
      "width": "60%",
      "left": "2%",
      "max-height": "100%"
    }
  }, [_c('div', {
    staticClass: "px-3 pt-2 text-left text--label-active"
  }, [_vm._v("You're invited")]), _c('div', {
    staticClass: "px-3 pb-2 text-left text--label-active"
  }, [_vm._v("To: ray@example.com")]), _c('v-divider'), _c('div', {
    staticClass: "pa-3 overflow-auto"
  }, [_c('web-media', {
    staticClass: "grey lighten-5",
    attrs: {
      "aspect-ratio": "376 / 640",
      "id": "36ec28cf-5995-455c-83d4-c6a4693e013b",
      "alt": "Example invitation email"
    }
  })], 1)], 1), _c('web-media', {
    staticClass: "absolute has-alpha r5",
    staticStyle: {
      "width": "50%",
      "top": "12%",
      "right": "1%"
    },
    attrs: {
      "aspect-ratio": "560 / 640",
      "id": "ec6d68fa-976b-469b-bcd3-09a393e8c412",
      "alt": "Example invitation text message"
    }
  })], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiEmailFast)
    }
  }), _vm._v(" Track deliveries")], 1), _c('div', [_vm._v("Send your invitation via email, text, or post a link on any platform. We'll keep track of all deliveries and report any issues, like out-of-date contact information.")])]), _c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "4 / 3"
    }
  }, [_c('web-media', {
    staticClass: "absolute rounded r5 white",
    staticStyle: {
      "width": "50%",
      "top": "0",
      "right": "2%"
    },
    attrs: {
      "aspect-ratio": "444 / 640",
      "id": "f83fdd46-5c0b-432d-9cd4-58c80fe4f507",
      "alt": "Example invitation follow-up"
    }
  }), _c('web-media', {
    staticClass: "absolute rounded rn3 white",
    staticStyle: {
      "width": "60%",
      "top": "12%",
      "left": "1%"
    },
    attrs: {
      "aspect-ratio": "640 / 550",
      "id": "25140c51-509a-4195-a1ee-5fae779fccd0",
      "alt": "Example send follow-up settings"
    }
  })], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiReminder)
    }
  }), _vm._v(" Send reminders and updates")], 1), _c('div', [_vm._v("Remind guests to RSVP or notify them of any changes.")])]), _c('web-media', {
    staticClass: "hover-pop rounded-xl white",
    attrs: {
      "aspect-ratio": "4 / 3",
      "id": "5113219f-9084-4745-b0fd-b0b830ae9447",
      "alt": "Piggy bank savings"
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCurrencyUsd)
    }
  }), _vm._v(" Pay less, get more")], 1), _c('div', [_vm._v(" Ellacard is the most affordable way to send an e-invitation. We think you'll come back to use our "), _c('router-link', {
    attrs: {
      "to": {
        name: 'start-group-cards'
      }
    }
  }, [_vm._v("group cards")]), _vm._v(", "), _c('router-link', {
    attrs: {
      "to": {
        name: 'start-holidays'
      }
    }
  }, [_vm._v("holiday cards")]), _vm._v(", "), _c('router-link', {
    attrs: {
      "to": {
        name: 'start-recognition'
      }
    }
  }, [_vm._v("cards for the office")]), _vm._v(", and more. "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pricing',
        hash: '#subscriptions'
      }
    }
  }, [_vm._v("Become a subscriber")]), _vm._v(" for even steeper discounts. ")], 1)])], 1), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-category',
        params: {
          category: 'invitations'
        },
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'INVITATION';
      }
    }
  }, [_vm._v("Start an invitation "), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "pink",
      "to": {
        hash: '#demo-first-birthday'
      }
    }
  }, [_vm._v("Try demo…")])], 1)]), _c('start-layer', {
    attrs: {
      "clip-waves-class": "dark-gradient",
      "offset": .9
    }
  }, [_c('h2', [_vm._v("Examples")]), _c('div', {
    staticClass: "grid-alternate"
  }, [_vm._l(_vm.EXAMPLES, function (ex) {
    return [_c('router-link', {
      staticClass: "d-block relative hover-pop rounded-xl",
      staticStyle: {
        "aspect-ratio": "4 / 3"
      },
      style: {
        'background-color': ex.color
      },
      attrs: {
        "title": ex.title + ' invitation demo',
        "to": {
          hash: ex.hash
        }
      }
    }, [_c('card-background', {
      staticClass: "overflow-hidden",
      staticStyle: {
        "border-radius": "24px"
      },
      attrs: {
        "src": ex.bg
      }
    }), _c('start-preview', {
      staticStyle: {
        "pointer-events": "none",
        "top": "10%",
        "left": "5%",
        "width": "90%"
      },
      attrs: {
        "alt": ex.title + ' example card',
        "pages": ex.pages
      }
    })], 1), _c('div', [_c('h4', {
      staticClass: "mb-3"
    }, [_vm._v(_vm._s(ex.title))]), _c('div', {
      staticClass: "mb-6"
    }, [_vm._v(_vm._s(ex.subtitle))]), _c('div', {
      staticClass: "ma-n2"
    }, [_c('v-btn', {
      staticClass: "btn-pop ma-2",
      attrs: {
        "rounded": "",
        "dark": "",
        "color": "ec-blue",
        "title": ex.title + ' invitation demo',
        "to": {
          hash: ex.hash
        }
      }
    }, [_vm._v(" Try demo… ")]), _c('v-btn', {
      staticClass: "btn-pop ma-2",
      attrs: {
        "rounded": "",
        "dark": "",
        "color": "ec-blue",
        "title": ex.title + ' invitations',
        "to": {
          name: 'catalog-category',
          params: {
            category: ex.category
          }
        }
      },
      on: {
        "!click": function ($event) {
          _vm.global.lastSelectedType = 'INVITATION';
        }
      }
    }, [_vm._v("More like this "), _c('v-icon', {
      staticClass: "mr-n1",
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1)], 1)])];
  })], 2), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-category',
        params: {
          category: 'invitations'
        },
        hash: '#search'
      }
    },
    on: {
      "!click": function ($event) {
        _vm.global.lastSelectedType = 'INVITATION';
      }
    }
  }, [_vm._v("Start an invitation "), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('start-reviews', {
    attrs: {
      "tag": "IN"
    }
  }), _c('start-footer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }